export const SEISMIC_SURVEY = 'seismic survey'
export const HORIZON = 'horizon'
export const POLYGON = 'polygon'
